import { useHistory } from 'react-router-dom'

import { STRING, SUPPORT_EMAIL } from 'resources'
import { APP_URLS } from 'resources/urls'

import ScreenContainer from 'components/ScreenContainer'

import { ConfirmButton, Container, Message, SupportLink, Title } from './styles'

const SharesSigningSuccess = () => {
  const history = useHistory()

  return (
    <ScreenContainer>
      <Container>
        <Title>{STRING.wallet.redemptions.shares.submitted.title}</Title>
        <Message>{STRING.wallet.redemptions.shares.submitted.description1}</Message>
        <Message>
          {STRING.wallet.redemptions.shares.submitted.description2}
          <SupportLink href={`mailto:${SUPPORT_EMAIL}`} target="_blank" rel="noopener noreferrer">
            {SUPPORT_EMAIL}
          </SupportLink>
          {STRING.wallet.redemptions.shares.submitted.description3}
        </Message>
        <ConfirmButton onPress={() => history.replace(APP_URLS.SHARES_FOR_REDEMPTION)}>
          {STRING.wallet.redemptions.shares.submitted.confirm}
        </ConfirmButton>
      </Container>
    </ScreenContainer>
  )
}

export default SharesSigningSuccess
